import { Plane, BookOpen, Wrench, Shield } from 'lucide-react';

// URL del backend
export const isLocalDev = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || 
   window.location.hostname.includes('preview.emergentagent.com'));
export const API_URL = isLocalDev ? (process.env.REACT_APP_BACKEND_URL || '') : '';

export const keyboardShortcuts = [
  { key: '←', action: 'Página anterior' },
  { key: '→', action: 'Página siguiente' },
  { key: 'Home', action: 'Primera página' },
  { key: 'End', action: 'Última página' },
  { key: '+', action: 'Zoom in' },
  { key: '-', action: 'Zoom out' },
  { key: '0', action: 'Reset zoom' },
  { key: 'F', action: 'Pantalla completa' },
  { key: 'R', action: 'Rotar página' },
];

export const aviationQuotes = [
  { quote: "El motor es el corazón del avión, pero el piloto es su alma.", author: "Walter Raleigh" },
  { quote: "La aviación es prueba de que, con suficiente determinación, hasta los cerdos pueden volar.", author: "Anónimo" },
  { quote: "Volar no es peligroso. Estrellarse sí lo es.", author: "Wilbur Wright" },
  { quote: "Un buen aterrizaje es aquel del cual puedes caminar. Uno excelente es cuando puedes usar el avión de nuevo.", author: "Regla de aviación" },
  { quote: "La única vez que tienes demasiado combustible es cuando estás en llamas.", author: "Regla de aviación" },
];

export const loadingStages = [
  { icon: Plane, text: 'Conectando con el servidor...', color: 'text-blue-400' },
  { icon: BookOpen, text: 'Preparando documento...', color: 'text-teal-400' },
  { icon: Wrench, text: 'Renderizando páginas...', color: 'text-amber-400' },
  { icon: Shield, text: 'Cargando visor seguro...', color: 'text-green-400' },
];

export const MAX_CONCURRENT_REQUESTS = 2;
export const MAX_CACHED_PAGES = 30;
